<template lang="pug">
  v-row
    v-col
      v-subheader.mt-4 {{ subheader }}
      utility-action-state(:action="changeRandomAssociation")
        template(#default="{ loading, trigger }")
          v-row(wrap)
            v-col(:cols="12")
              v-card
                v-card-text
                  v-row.align-center(dense)
                    v-col.shrink
                      feature-avatar.mr-4(
                        :size="100 / $goldenRatio"
                        v-shared-element:heroId="{ includeChildren: true, ignoreTransparency: true }"
                        :lazy-src="$get(getImage(), `srcLazy`)"
                        :src="$get(getImage(), `src`)")
                    v-col
                      v-row
                        v-col.text-truncate(style="font-size: 22px") {{ getName() || '\xa0' }}
                      v-row.align-center.mt-2
                        v-col
                          v-btn(
                            @click="goToRandomEntity"
                            block
                            :disabled="loading"
                            text) Visiter
                        v-col
                          utility-action-state(:action="() => doSupport({ supportedAssociationId: $get(randomAssociation, `id`) })")
                            template(#default="{ loading, trigger }")
                              v-btn(
                                @click="trigger"
                                :loading="loading"
                                outlined
                                rounded
                                :disabled="loading"
                                block) Soutenir
            v-col.text-center.pt-0(:cols="12")
              v-btn.elevation-2(
                @click="trigger"
                :ripple="false"
                :disabled="loading"
                fab
                small)
                v-icon {{ mdiRefresh }}
</template>

<script>
import { mdiRefresh } from '@mdi/js'
import UtilityActionState from '@iez/components/utility/action-state/'
import { ref } from '@vue/composition-api'

export default {
  components: {
    UtilityActionState
  },

  props: {
    subheader: String,
    root: String,
    fields: Array,
    getImage: Function,
    getName: Function,
    goToRandomEntity: Function
  },

  setup (props) {
    const seed = ref(Math.random())
    const lastEntityId = ref(null)
    const randomEntity = data.get({
      root: props.root,
      fields: props.fields,
      realtime: true,
      random: true,
      one: true,
      fetchPolicy: `network-only`,
      request: () => ({
        args: {
          seed: `${seed.value}`
        },
        ...lastEntityId.value
          ? {
            where: {
              id: {
                _neq: lastEntityId.value
              }
            }
          } : null
      })
    })

    const changeRandomEntity = () => {
      seed.value = Math.random()
      lastEntityId.value = randomEntity.value.id
      randomEntity.value = null

      return waitFor({
        dependencies: () => randomEntity.value
      })
    }


    return {
      mdiRefresh
    }
  }
}
</script>
